import { createAnimation } from '@ionic/vue';

const SCANNER_MODAL_DURATION_MS = 320;
const SCANNER_MODAL_EASING = 'cubic-bezier(0.32, 0.72, 0, 1)';

export function scannerModalTransition(_baseEl, opts = {}) {
  const enteringEl = opts.enteringEl;
  const leavingEl = opts.leavingEl;
  const isClosing = opts.direction === 'back';
  const animations = [];

  if (isClosing) {
    if (leavingEl) {
      animations.push(
        createAnimation()
          .addElement(leavingEl)
          .beforeStyles({ 'z-index': '99' })
          .afterClearStyles(['transform', 'opacity', 'z-index'])
          .fromTo('transform', 'translateY(0)', 'translateY(100%)')
          .fromTo('opacity', '1', '1'),
      );
    }

    if (enteringEl) {
      animations.push(
        createAnimation()
          .addElement(enteringEl)
          .beforeStyles({ 'z-index': '0' })
          .afterClearStyles(['transform', 'opacity', 'z-index'])
          .fromTo('opacity', '1', '1'),
      );
    }
  } else {
    if (enteringEl) {
      animations.push(
        createAnimation()
          .addElement(enteringEl)
          .beforeStyles({ 'z-index': '99' })
          .afterClearStyles(['transform', 'opacity', 'z-index'])
          .fromTo('transform', 'translateY(100%)', 'translateY(0)')
          .fromTo('opacity', '1', '1'),
      );
    }

    if (leavingEl) {
      animations.push(
        createAnimation()
          .addElement(leavingEl)
          .beforeStyles({ 'z-index': '0' })
          .afterClearStyles(['transform', 'opacity', 'z-index'])
          .fromTo('opacity', '1', '1'),
      );
    }
  }

  return createAnimation()
    .duration(SCANNER_MODAL_DURATION_MS)
    .easing(SCANNER_MODAL_EASING)
    .addAnimation(animations);
}
